angular.module('am4').filter('webDisplayName', ($translate) => {
    return (input) => {
        if (!input) {
            return null;
        }
        try {
            const parts = JSON.parse(input);
            if (parts.frame && parts.console) {
                return $translate.instant('A_WITH_B', {
                    a: parts.frame,
                    b: parts.console
                });
            }
            return parts.frame || parts.console || null;
        } catch (e) {
            return input;
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/filters/webDisplayName.js